// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* QuizComponents.css */
.quiz-question {
  margin-bottom: 2rem;
  padding: 1rem;
}

.question-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #005c69;
}

.question-content {
  display: flex;
  flex-direction: column;
}

.options-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.option-item {
  margin-bottom: 0.75rem;
}

.option-label {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  border-radius: 0.375rem;
  transition: background-color 0.15s ease-in-out;
  cursor: pointer;
  background-color: #f1f1f1;
  width: 100%;
}

.option-label:hover {
  background-color: #e6e6e6;
}

.option-input {
  margin-right: 1.5rem; /* Increase the space between the radio button and the text */
}

.option-text {
  color: #374151;
  flex-grow: 1;
  margin-left: 1.5rem;
}

.fill-input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid rgba(209, 213, 219, 0.5);
  border-radius: 0.375rem;
  font-size: 1rem;
  background-color: #f1f1f1;
  color: #374151;
}

.fill-input:focus {
  outline: none;
  border-color: #005c69;
  box-shadow: 0 0 0 3px rgba(0, 92, 105, 0.1);
}

.matching-container {
  width: 100%;
}

.matching-grid {
  display: grid;
  grid-template-columns: 1fr 1fr; /* Adjust the columns to be equal */
  gap: 1rem;
}

.matching-column {
  display: flex;
  flex-direction: column;
}

.matching-item,
.matching-description-item {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
}

.matching-term {
  font-weight: 500;
  margin-right: 0.5rem;
  color: #374151;
  flex: 1 1;
}

.matching-select {
  width: auto;
  padding: 0.5rem;
  border: 1px solid rgba(209, 213, 219, 0.5);
  border-radius: 0.375rem;
  background-color: #f1f1f1;
  color: #374151;
}

.matching-description {
  display: inline-block;  /* Ensure the container fits the content */
  padding: 0.75rem;
  align-items: center;
  justify-content: center;
  background-color: #f1f1f1;
  border-radius: 0.25rem;
  margin-bottom: 1rem;
  word-break: break-word; /* Ensure long words break correctly */
  flex: auto;
}

.explanation {
  margin-top: 1rem;
  padding: 0.75rem;
  background-color: #e6e6e6;
  border-radius: 0.375rem;
}

.explanation-text {
  font-size: 1rem;
  color: #222222;
}

.correct {
  background-color: rgba(46, 204, 113, 0.3);
}

.incorrect {
  background-color: rgba(231, 76, 60, 0.3);
}

.disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.short-answer-container {
  display: flex;
  flex-direction: column;
}

.short-answer-input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid rgba(209, 213, 219, 0.5);
  border-radius: 0.375rem;
  font-size: 1rem;
  background-color: #f1f1f1;
  color: #374151;
  resize: none; /* Prevent resizing */
}

.short-answer-input:focus {
  outline: none;
  border-color: #005c69;
  box-shadow: 0 0 0 3px rgba(0, 92, 105, 0.1);
}

.teacher-feedback {
  margin-top: 1rem;
  padding: 0.75rem;
  background-color: #e6e6e6;
  border-radius: 0.375rem;
}

.teacher-feedback h4 {
  margin-bottom: 0.5rem;
}

.teacher-feedback p {
  margin: 0;
}

/* Media queries for responsive design */
@media (max-width: 768px) {

  .question-title {
    font-size: 1rem;
  }


  .option-input {
    margin-right: 0;
    margin-bottom: 0.5rem;
  }


  .matching-grid {
    grid-template-columns: 1fr;
  }

  .matching-description {
    margin-top: 0.5rem;
  }
}

@media (max-width: 480px) {

  .question-title {
    font-size: 0.875rem;
  }

  .fill-input {
    font-size: 0.875rem;
  }

  .short-answer-input {
    font-size: 0.875rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/quiz/QuizComponents.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,8CAA8C;EAC9C,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB,EAAE,6DAA6D;AACrF;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,0CAA0C;EAC1C,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,mCAAmC;EACnE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,WAAW;EACX,eAAe;EACf,0CAA0C;EAC1C,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB,GAAG,0CAA0C;EAClE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB,EAAE,sCAAsC;EAC9D,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,0CAA0C;EAC1C,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,YAAY,EAAE,qBAAqB;AACrC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA,wCAAwC;AACxC;;EAEE;IACE,eAAe;EACjB;;;EAGA;IACE,eAAe;IACf,qBAAqB;EACvB;;;EAGA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;EAEE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* QuizComponents.css */\n.quiz-question {\n  margin-bottom: 2rem;\n  padding: 1rem;\n}\n\n.question-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: #005c69;\n}\n\n.question-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.options-list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.option-item {\n  margin-bottom: 0.75rem;\n}\n\n.option-label {\n  display: flex;\n  align-items: center;\n  padding: 0.75rem;\n  border-radius: 0.375rem;\n  transition: background-color 0.15s ease-in-out;\n  cursor: pointer;\n  background-color: #f1f1f1;\n  width: 100%;\n}\n\n.option-label:hover {\n  background-color: #e6e6e6;\n}\n\n.option-input {\n  margin-right: 1.5rem; /* Increase the space between the radio button and the text */\n}\n\n.option-text {\n  color: #374151;\n  flex-grow: 1;\n  margin-left: 1.5rem;\n}\n\n.fill-input {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid rgba(209, 213, 219, 0.5);\n  border-radius: 0.375rem;\n  font-size: 1rem;\n  background-color: #f1f1f1;\n  color: #374151;\n}\n\n.fill-input:focus {\n  outline: none;\n  border-color: #005c69;\n  box-shadow: 0 0 0 3px rgba(0, 92, 105, 0.1);\n}\n\n.matching-container {\n  width: 100%;\n}\n\n.matching-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr; /* Adjust the columns to be equal */\n  gap: 1rem;\n}\n\n.matching-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.matching-item,\n.matching-description-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.matching-term {\n  font-weight: 500;\n  margin-right: 0.5rem;\n  color: #374151;\n  flex: 1;\n}\n\n.matching-select {\n  width: auto;\n  padding: 0.5rem;\n  border: 1px solid rgba(209, 213, 219, 0.5);\n  border-radius: 0.375rem;\n  background-color: #f1f1f1;\n  color: #374151;\n}\n\n.matching-description {\n  display: inline-block;  /* Ensure the container fits the content */\n  padding: 0.75rem;\n  align-items: center;\n  justify-content: center;\n  background-color: #f1f1f1;\n  border-radius: 0.25rem;\n  margin-bottom: 1rem;\n  word-break: break-word; /* Ensure long words break correctly */\n  flex: auto;\n}\n\n.explanation {\n  margin-top: 1rem;\n  padding: 0.75rem;\n  background-color: #e6e6e6;\n  border-radius: 0.375rem;\n}\n\n.explanation-text {\n  font-size: 1rem;\n  color: #222222;\n}\n\n.correct {\n  background-color: rgba(46, 204, 113, 0.3);\n}\n\n.incorrect {\n  background-color: rgba(231, 76, 60, 0.3);\n}\n\n.disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.short-answer-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.short-answer-input {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid rgba(209, 213, 219, 0.5);\n  border-radius: 0.375rem;\n  font-size: 1rem;\n  background-color: #f1f1f1;\n  color: #374151;\n  resize: none; /* Prevent resizing */\n}\n\n.short-answer-input:focus {\n  outline: none;\n  border-color: #005c69;\n  box-shadow: 0 0 0 3px rgba(0, 92, 105, 0.1);\n}\n\n.teacher-feedback {\n  margin-top: 1rem;\n  padding: 0.75rem;\n  background-color: #e6e6e6;\n  border-radius: 0.375rem;\n}\n\n.teacher-feedback h4 {\n  margin-bottom: 0.5rem;\n}\n\n.teacher-feedback p {\n  margin: 0;\n}\n\n/* Media queries for responsive design */\n@media (max-width: 768px) {\n\n  .question-title {\n    font-size: 1rem;\n  }\n\n\n  .option-input {\n    margin-right: 0;\n    margin-bottom: 0.5rem;\n  }\n\n\n  .matching-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .matching-description {\n    margin-top: 0.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n\n  .question-title {\n    font-size: 0.875rem;\n  }\n\n  .fill-input {\n    font-size: 0.875rem;\n  }\n\n  .short-answer-input {\n    font-size: 0.875rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
